'use strict';

var debugMode = require('./debugMode');

var utils = module.exports = {};

var trackPrefix = 'data-track-';
var hxtrackPrefix = 'data-hxtrack-';

var CLICK = 1;
var FOCUS = 2;
var CHANGE = 4;
var NONE = 0;
var TRACKING_LEVELS = {
  checkbox: CLICK,
  radio: CLICK,
  INPUT: FOCUS | CHANGE,
  TEXTAREA: FOCUS | CHANGE,
  HTML: NONE,
  FORM: NONE,
  BODY: NONE
};

utils._trackingLevel = function (element) {
  if (element.type in TRACKING_LEVELS) {
    return TRACKING_LEVELS[element.type];
  }
  if (element.nodeName in TRACKING_LEVELS) {
    return TRACKING_LEVELS[element.nodeName];
  }
  return CHANGE | CLICK;
};

utils._getAttribute = function (element, attribute) {
  return element && element.getAttribute && element.getAttribute(attribute);
};

var _getElement = function _getElement(event) {
  return event.target || event.srcElement;
};

utils._stringify = function (obj) {
  try {
    return JSON.stringify(obj);
  } catch (e) {
    return '';
  }
};

utils._getTarget = function (element, weCareAboutTrackingThisElement, originalElementForDebug) {
  if (!element) {
    return null;
  }
  var level = utils._trackingLevel(element);
  if (level) {
    weCareAboutTrackingThisElement = true;
    if (utils._getName(element)) return element;
  }
  return utils._getTarget(element.parentNode, weCareAboutTrackingThisElement, originalElementForDebug || element);
};

utils._elementChecks = function (element) {
  if (debugMode.get()) {
    var hxtrackName = utils._getAttribute(element, hxtrackPrefix + 'name');
    var trackName = utils._getAttribute(element, trackPrefix + 'name');
    if (hxtrackName || trackName) {
      console.warn('🛤 Legacy name for element:', element);
    }

    var trackValue = utils._getAttribute(element, trackPrefix + 'value'); // do we still need data-track-value?
    var hxtrackValue = utils._getAttribute(element, hxtrackPrefix + 'value');

    if (hxtrackValue || trackValue) {
      console.warn('🛤 Legacy value for element:', element);
    }

    if (!utils._getName(element)) {
      console.warn('🛤 No name found for element:', element);
    }
  }
};

utils._getName = function (element) {
  if (!element) return null;

  var id = utils._getAttribute(element, 'id');
  var name = utils._getAttribute(element, 'name');
  var hxtrackName = utils._getAttribute(element, hxtrackPrefix + 'name');
  var trackName = utils._getAttribute(element, trackPrefix + 'name');

  return name || id || trackName || hxtrackName;
};

function censorWithinLimits(start, end) {
  return function (char, count) {
    return count >= start && count < end ? '*' : char;
  };
}

utils._getValue = function (element) {
  if (!element) return undefined;

  var attribValue = utils._getAttribute(element, 'value'); // the value attribute, for an anchor say
  var trackValue = utils._getAttribute(element, trackPrefix + 'value'); // do we still need data-track-value?
  var hxtrackValue = utils._getAttribute(element, hxtrackPrefix + 'value');

  var value = element.value || attribValue || trackValue || hxtrackValue;

  // if someone clicks on a checkbox we need to know if it's checked or unchecked
  if (element.type === 'checkbox' && !element.checked) value = '';

  if (!value) return value; // don't try and censor null or undefined

  if (utils._getAttribute(element, 'type') === 'password') return '*';

  var nameAttribute = utils._getName(element);
  if (/(pass|keyphrase|pin)/i.test(nameAttribute)) return '*';

  var censored = utils._getAttribute(element, 'data-censor');

  if (!censored) return value;

  value = '' + value; // must be a string to censor part of it
  var start = 0;
  var end = value.length;
  var match = /first-(\d+)/.exec(censored);
  if (match) start = match[1];
  match = /last-(\d+)/.exec(censored);
  if (match) end -= match[1];
  return value.replace(/./g, censorWithinLimits(start, end));
};

utils._on = function (element, eventType, callback, bubbles, timeout) {
  var on = 'on' + eventType;
  if (element.addEventListener) element.addEventListener(eventType, callback, bubbles);else if (element.attachEvent) element.attachEvent(on, callback);else if (element[on]) element[on] = callback;else if (timeout) {
    // this option added only because orion supported it
    if (process.env.NODE_ENV !== 'production') {
      console.warn('we are in a browser that does not have window.onload');
    }
    setTimeout(callback, timeout);
  }
};

utils._onClick = function (Tracker, event) {
  utils._genericInferredEvent(Tracker, event, 'click', CLICK);
  try {
    var selection = '' + window.getSelection();
    if (selection) Tracker.c('get-selection', selection);
  } catch (err) {}
};

utils._genericInferredEvent = function (Tracker, event, trackingType, trackingLevel) {
  var element = _getElement(event);
  if (utils._trackingLevel(element) & trackingLevel) {
    // logical AND
    var target = utils._getTarget(element); // this element or the parent?
    utils._elementChecks(element);
    if (target) {
      var payload = {
        name: utils._getName(target),
        value: utils._getValue(target)
      };
      if (trackingType === 'capture' && Boolean(utils._getAttribute(target, 'data-public'))) {
        trackingType = 'public_capture';
      }
      Tracker.inline(trackingType, payload);
    }
  }
};

utils._onChange = function (Tracker, event) {
  utils._genericInferredEvent(Tracker, event, 'capture', CHANGE);
};

utils._onFocus = function (Tracker, event) {
  utils._genericInferredEvent(Tracker, event, 'focus', FOCUS);
};

// Track bytes transferred to the browser whilst they have been on the page
utils._onBeforeunload = function (Tracker, event) {
  var performance = window.performance;
  if (performance && typeof performance.getEntries === 'function') {
    var total = 0;
    var entries = performance.getEntries();
    for (var i = entries.length - 1; i >= 0; --i) {
      var entry = entries[i];
      if (entry && entry.transferSize) {
        total += entry.transferSize;
      }
    }
    Tracker.c('bytes-transferred', total.toString());
  }
};